import { render, staticRenderFns } from "./login-screen.vue?vue&type=template&id=9c31b330&scoped=true&"
import script from "./login-screen.vue?vue&type=script&lang=js&"
export * from "./login-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c31b330",
  null
  
)

export default component.exports